import './AppLoader.scss';

export const AppLoader = (): JSX.Element => (
  <div className="lds-ellipsis">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
);
